import React, { useRef } from 'react'

const features = [
    {
        icon: 'bx-support',
        title: 'Soporte cercano',
        text: 'Te acompañamos antes, durante y después del lanzamiento.',
    },
    {
        icon: 'bx-bot',
        title: 'Tecnología + IA',
        text: 'Aprovechamos las mejores herramientas para entregar más rápido y mejor.',
    },
    {
        icon: 'bx-line-chart',
        title: 'Resultados reales',
        text: 'Cada proyecto se piensa para que aporte valor a tu negocio.',
    },
    {
        icon: 'bx-globe',
        title: '100% online',
        text: 'Atención remota desde Asunción para todo Paraguay y la región.',
    },
];

const Nosotros = () => {
    const cardRef = useRef(null);

    const handleMouseMove = (e) => {
        const card = cardRef.current;
        if (!card) return;
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = ((y - centerY) / centerY) * -12;
        const rotateY = ((x - centerX) / centerX) * 14;
        card.style.setProperty('--rx', `${rotateX}deg`);
        card.style.setProperty('--ry', `${rotateY}deg`);
        card.style.setProperty('--mx', `${(x / rect.width) * 100}%`);
        card.style.setProperty('--my', `${(y / rect.height) * 100}%`);
    };

    const handleMouseLeave = () => {
        const card = cardRef.current;
        if (!card) return;
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--mx', '50%');
        card.style.setProperty('--my', '50%');
    };

    return (
        <section id='nosotros'>
            <div className="container pt-5">
                <div className="row justify-content-center align-items-center pb-5 pt-5">
                    <div className="col-10 col-md-6 d-flex justify-content-center mb-5 mb-md-0">
                        <div
                            ref={cardRef}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave}
                            className="ds-3d-stage"
                        >
                            <div className="ds-3d-card">
                                <div className="ds-3d-grid"></div>
                                <div className="ds-3d-glow ds-3d-glow--cyan"></div>
                                <div className="ds-3d-glow ds-3d-glow--blue"></div>
                                <div className="ds-3d-spotlight"></div>

                                <div className="ds-3d-tag ds-3d-tag--top">
                                    <span className="ds-3d-dot"></span>
                                    DSCODE.PY
                                </div>
                                <div className="ds-3d-tag ds-3d-tag--bottom">{'// online · paraguay'}</div>

                                <div className="ds-3d-monogram">
                                    <span>DS</span>
                                </div>

                                <div className="ds-3d-stats">
                                    <div className="ds-3d-stat">
                                        <span className="ds-3d-num">+10</span>
                                        <span className="ds-3d-label">
                                            <span className="d-none d-sm-inline">Proyectos</span>
                                            <span className="d-sm-none">Proy.</span>
                                        </span>
                                    </div>
                                    <div className="ds-3d-divider"></div>
                                    <div className="ds-3d-stat">
                                        <span className="ds-3d-num">2023</span>
                                        <span className="ds-3d-label">Desde</span>
                                    </div>
                                    <div className="ds-3d-divider"></div>
                                    <div className="ds-3d-stat">
                                        <span className="ds-3d-num">100%</span>
                                        <span className="ds-3d-label">Online</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-10 col-md-5 text-white">
                        <span className="ds-eyebrow">Sobre Dscode</span>
                        <h2 className='mt-2 mb-3 ds-titulo'>
                            Más que un sitio web, <span className="ds-highlight">una solución completa</span>
                        </h2>
                        <p className='mb-4 ds-lead'>
                            Dscode nace en 2023 con una misión clara: ayudar a emprendedores y empresas a crecer en el mundo digital. Trabajamos 100% online desde Paraguay, combinando desarrollo a medida  para que cada landing, ecommerce o sistema realmente aporte a tu negocio.
                        </p>

                        <div className="ds-features">
                            {features.map((f) => (
                                <div key={f.title} className="ds-feature">
                                    <div className="ds-feature-icon">
                                        <i className={`bx ${f.icon}`}></i>
                                    </div>
                                    <div>
                                        <div className="ds-feature-title">{f.title}</div>
                                        <p className="ds-feature-text mb-0">{f.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Nosotros
